export const BankAccountType = {
  FIO: 'fio',
}

export const bankAccountTypeName = {
  [BankAccountType.FIO]: 'FIO a.s.',
};
